import React from 'react';

import { Chip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { MigrationReportStatus } from 'types';

import { STATUS_COLORS } from './constants';

interface ReportStatusChipProps {
  status: MigrationReportStatus;
}

export const ReportStatusChip = ({ status }: ReportStatusChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      label={t(`pages.migrationReports.status.${status}`, status)}
      style={{ backgroundColor: STATUS_COLORS[status] ?? STATUS_COLORS.pending, color: '#fff' }}
    />
  );
};
